import React, {useMemo, useEffect, useState} from "react";
import { useLocation } from 'react-router-dom';
import { Row, Col, Card, CardBody, Container, } from "reactstrap";
import { FormGroup, SaveButton, } from "components/common";
import { compose, withState, withStateHandlers } from "recompose";
import { LocalForm, Control, } from "react-redux-form";
import { Trans, withTranslation, } from "react-i18next";
import countryList from 'react-select-country-list';
import Select from "react-select";
import { ApiClient, } from "services";
import { formatDate } from "services/util";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { NotificationManager } from "react-notifications";
import { useOrganisationContext } from "hooks";
import LoadingMsg from "components/common/LoadingMsg";
import { parseAPIError, getDateAfterDays } from "../../../Helpers"
import BillingContactForm, { hasBillingAddressData } from "components/BillingContact/BillingContactForm";
import { CurrencySymbol } from "services/util";


const useSelection = () => {
  const [selectedItems, setSelectedItems] = useState([]);

  const handleToggle = (feature) => {
    if (selectedItems.some(item => item.object_id === feature.object_id)) {
      setSelectedItems(selectedItems.filter(item => item.object_id !== feature.object_id));
    } else {
      setSelectedItems([...selectedItems, feature]);
    }
  };

  return [selectedItems, handleToggle];
};

export const PaymentSummary = ({
  item,
  form,
  setDispatch,
  onUpdate,
  onChange,
  dispatch,
  match,
  t
}) => {

  const currentDate = new Date().toDateString()

  const countryOptions = useMemo(() => countryList().getData(), [])
  
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [redirecting, setRedirecting] = useState();
  const [priceValue, setPriceValue] = useState();
  const [currency, setCurrency] = useState('SAR');
  const [subscriptionData, setSubscriptionData] = useState();
  const [currentSubscriptionData, setCurrentSubscriptionData] = useState({});

  const [promoCode, setPromoCode] = useState();
  const [promoCodeData, setPromoCodeData] = useState(null)
  const [billingData, setBillingData] = useState({})
  const [addNewContact, setAddNewContact] = useState(true)
  const [billingAddressId, setBillingAddressId] = useState(null)
  const [subscriptionPeriod, setSubscriptionPeriod] = useState({
    start_date: currentDate,
    end_date: getDateAfterDays(currentDate, 'Yearly').toDateString(),
  })

  const [languageData, setLanguageData] = useState();
  const [selectedLang, handleLanguageToggle] = useSelection();

  const [selectedLangIds, setSelectedLangIds] = useState([]);
  const [selectedOption, setSelectedOption] = useState('Yearly'); // Default to Yearly
  const [billingCountry, setBillingCountry] = useState(null); // Track billing country from form

  const { selectedOrganisation } = useOrganisationContext();  

  const history = useHistory()
  const client = ApiClient()

  const connectedOrg = selectedOrganisation ? selectedOrganisation?.id : 0

  const searchParams = new URLSearchParams(search);
  const changeType = searchParams.get('action');
  
  const subscriptionID = match.params.id

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        const res = await client.get(`subscription-plans/${subscriptionID}`);
        const data = res.data;
        setSubscriptionData(data);
        setLoading(false)
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false)
      }
    };

    const fetchSubscriptionData = async () => {
      if (connectedOrg !== 0) {
        try {
          const res = await client.get(`connected_organisations/${connectedOrg}/subscription`);
          setCurrentSubscriptionData(res.data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }  

    const fetchBillingData = async () => {
      try {
        const billing = await client.get(`/connected_organisations/${connectedOrg}/billing-address`);
        setBillingData(billing.data)
        setAddNewContact(!hasBillingAddressData(billing.data?.default_address).isValid)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } 

    fetchData();

    fetchData()

    fetchSubscriptionData()

    fetchBillingData()

  }, [selectedOrganisation]);

  useEffect(() => { 
    const fetchLanguageData = async () => {
      try {
        const responseL = await client.get("core/hesaab_language");
        const planInclusiveLangIds = subscriptionData?.subscription_plan_inclusives?.filter(item => item.content_type === 'hesaablanguage').map(item => item.object_id)
        const ldata = responseL.data && responseL.data.filter(item => !['en', 'ar'].includes(item.code) && !planInclusiveLangIds.includes(item.id))
        setLanguageData(ldata);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (subscriptionData) { 
      fetchLanguageData();
      
      // Initialize with default yearly plan values
      const yearlyPlan = subscriptionData?.subscription_prices?.find(item => item.plan_type === "Yearly");
      if (yearlyPlan && !priceValue) {
        setPriceValue(yearlyPlan.price);
        setCurrency(yearlyPlan.currency);
      }
    }
  }, [subscriptionData])

  let planType = [
    // {value: "Monthly", label: t("Monthly")},
    {value: "Yearly", label: t("Yearly")}
  ]

  const monthlyPlan = subscriptionData?.monthly_price;
  const yearlyPlan = subscriptionData?.yearly_price;

  const handleChange = (selectedPlan) => {
    if (selectedPlan) {
      setSelectedOption(selectedPlan); // Update the selected option state
      
      if (selectedPlan === 'Monthly' && monthlyPlan) {
        setPriceValue(monthlyPlan.price);
        setCurrency(monthlyPlan.currency)
      } else if (selectedPlan === 'Yearly' && yearlyPlan) {
        setPriceValue(yearlyPlan.price);
        setCurrency(yearlyPlan.currency)
      } else {
        console.log('Invalid selection or plan not found');
      }

      let endDate = getDateAfterDays(currentDate, selectedPlan)
      setSubscriptionPeriod({
        start_date: currentDate,
        end_date: endDate.toDateString(),
      })

    } else {
      console.log('Invalid selection');
    }
  };

  // VAT calculation function
  const calculateVATAmount = (price, country, vatRate, isVatIncluded) => {
    // Apply VAT only for Saudi Arabia
    if (country === 'SA') {
      if (isVatIncluded) {
        // If VAT is included, extract VAT from the total price
        // VAT amount = (price * vatRate) / (1 + vatRate)
        return (price * vatRate) / (1 + vatRate);
      } else {
        // If VAT is not included, add VAT to the base price
        return price * vatRate;
      }
    }
    return 0;
  };

  // Function to get base price (excluding VAT)
  const getBasePrice = (price, vatRate, isVatIncluded) => {
    if (isVatIncluded) {
      // If VAT is included, calculate base price by removing VAT
      return price / (1 + vatRate);
    }
    // If VAT is not included, the price is already the base price
    return price;
  };

  const handleBillingCountryChange = (value) => {     
    setBillingCountry(value);
  };

  // Get the billing country from billing data or state
  const currentBillingCountry = billingCountry || billingData?.default_address?.country;

  // Get the current plan and its VAT inclusion status
  const currentPlan = selectedOption === 'Monthly' ? monthlyPlan : yearlyPlan;
  const isVatIncluded = currentPlan?.is_vat_included || false;
  
  // Get the original price from the plan
  const originalPrice = priceValue ? priceValue : yearlyPlan?.price || 0;
  
  // Calculate base price (excluding VAT) and VAT amount
  const basePrice = getBasePrice(originalPrice, subscriptionData?.vat_rate, isVatIncluded);
  const vatAmount = calculateVATAmount(originalPrice, currentBillingCountry, subscriptionData?.vat_rate, isVatIncluded);
  
  // Final price including VAT
  let showPrice = parseFloat(basePrice + vatAmount).toFixed(2);

  function snakeToTitle(str) {
    return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  const calculateDiscount = (orderTotal, promoCodeDetails) => {
    let discount = 0
    
    if (promoCodeDetails.code_type === "Percent") {
      // Calculate discount amount based on percentage
      discount = (orderTotal * promoCodeDetails.discount) / 100;
    } else if (promoCodeDetails.code_type === "Price value") {
      // Assuming a fixed discount
      discount = promoCodeDetails.discount;
    } else {
      discount = 0; // No discount if discount type is unknown
    }
    
    return discount;
  }

  const applyPromoCode = async () => {
    if (!promoCode) {
      NotificationManager.Alert('Enter promo code!')
      return
    }

    let postData = {
      code: promoCode,
    }

    try {
      setLoading(true)

      await client.post(`core/hesaab-promo-code/apply-promo-code`, postData).then(res => {
        const data = res.data;

        let discount = calculateDiscount(basePrice, data).toFixed(2)
        
        let promoDetails = {
          discount_type: data.code_type,
          discount_amount: data.discount,
          discounted_price: discount,
          code: data.code,
        }
        setPromoCodeData(promoDetails)
        NotificationManager.success('Promo code applied.')
      }).catch(error => {
        let errorMsg = parseAPIError(error)

        if (Array.isArray(errorMsg)) {
          errorMsg.forEach((value) => {
            NotificationManager.error(value)
          })

        } else {
          NotificationManager.error(errorMsg)
        }
      });
      
      setLoading(false)
    } catch (error) {
      console.log(error);
      setLoading(false)
    }
  }

  const responseError = "No Response from the server, please try again"

  const handlePost = async (values) => {
    
    let postData = Object.assign({}, values)

    if (promoCode && promoCodeData) {
      postData['promo_code'] = promoCode
    }

    if (!addNewContact && !billingAddressId) {
      NotificationManager.error(t('Select billing contact.'))
      return
    }

    const billingValidation = hasBillingAddressData(postData.billing_address_data);
    if (!billingAddressId && !billingValidation.isValid) {
      NotificationManager.error(billingValidation.error || t('Select billing contact or enter all billing contact data.'))
      return
    }

    if (billingAddressId) {
      postData['billing_address'] = billingAddressId
      delete postData.billing_address_data
    } else if (billingValidation.isValid) {
      postData['billing_address_data'] = postData.billing_address_data
      delete postData.billing_address
    }

    if (selectedLang.length > 0) {
      postData['features'] = selectedLang
    }
    
    let endpoint = '/new-subscription'

    if (['Active', 'Expired'].includes(currentSubscriptionData?.current_plan?.subscription_status)) {
      endpoint = '/change-subscription'

      postData['change_type'] = changeType
    } 

    client.post(endpoint, postData)
      .then(response => {
          NotificationManager.success(t('Details Confirmed, You will be re-directed to payment!'));
          setIsSending(false);
          setTimeout(() => {
            setRedirecting(true)
            if (response.data.id) {
            client.post(`/payment`, {invoice: response?.data?.id})
              .then(res => {
              NotificationManager.success(t('Payment details sent to TAP!'));
              setTimeout(() => {
                if (res?.data.transaction_url) {
                window.location.href = res?.data.transaction_url;
              } else {
                NotificationManager.error(t(responseError))
                setRedirecting(false)
                return
              }
              }, 500);
            })} else {
              NotificationManager.error(t(responseError))
              setRedirecting(false)
              return
            }
          }, 500);
      })
      .catch(error => {
        console.error("Error:", error);
        if (error.response && error.response.data) {
          const errors = error.response.data;
          Object.entries(errors).forEach(([key, value]) => {
            const fieldName = snakeToTitle(key);
            const errorMessage = `${fieldName} - ${value}`;
            if (errorMessage === "Connected Organisation - Invalid pk \"0\" - object does not exist.") {
              NotificationManager.error(t("Your connected organisation cannot be determined"))
            } else {
            NotificationManager.error(errorMessage)
          }
          });
        } else {
          NotificationManager.error(t("An error occurred while saving"));
        }
        setIsSending(false);
      });
  };

  const showTotalPrice = (subTotal, vatAmount = 0, discountedAmount = 0, unusedPrice = 0, changeType = '') => { 
    let totalPrice = subTotal + vatAmount - (discountedAmount || 0)
    
    if (changeType !== 'renew') {
      totalPrice -= unusedPrice
    }

    return totalPrice.toFixed(2)
  }

  if (currentSubscriptionData?.current_plan?.billing_cycle === 'Yearly') {
    planType = [
      {value: "Yearly", label: t("Yearly")}
    ]
  }

  const colStyle = {
    xs: false,
    md: 6,
    className: "pt-1 pb-1"
  }
  
  const styleCheck = {
    style:{fontSize: "1rem"},
    className:"ml-2"
  }

  const checkboxStyle = {
    style: { position: 'relative', marginTop: 0, marginInlineStart: 0, }
  }

  const onChangeModule = (feature, contentType) => {
    if (contentType === 'hesaablanguage') {
      handleLanguageToggle(feature)

      if (!selectedLangIds.includes(feature.object_id)) {
        setSelectedLangIds([...selectedLangIds, feature.object_id])
      } else {
        setSelectedLangIds(selectedLangIds.filter(id => id !== feature.object_id))
      }
    }
  }

  return (
    <div className='payment-summary'>
      <Container>
        <Row>
          <Col xs={false}>
            <Card>
              <CardBody>
                {redirecting ? <LoadingMsg message="Redirecting"/> :
                <LocalForm
                  initialState={item}
                  onSubmit={values => handlePost(values)}
                  getDispatch={setDispatch}
                  onUpdate={onUpdate}
                  onChange={onChange}
                >

                  <Row>
                    <Col {...colStyle}>
                      <FormGroup label={t("connected_organisation *")} hidden={connectedOrg !== 0}>
                        <Control.text
                          model=".connected_organisation"
                          defaultValue={connectedOrg}
                        />
                      </FormGroup>
                    </Col>
                    <Col {...colStyle}>
                      <FormGroup label={t("subscription_plan *")} hidden={connectedOrg !== 0}>
                        <Control.text
                          model=".subscription_plan"
                          defaultValue={subscriptionID}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  
                  <Row>
                    <div className="col-md-7 col-lg-8">
                      { subscriptionData && subscriptionData.additional_language_limit > 0 && <>
                        <h4 className="mb-3">
                          <Trans>Additional Languages</Trans>
                        </h4>

                        <Row>
                          <Col md="12" xs={false}>
                            <span className="d-print-none">{ t(`You can choose up to ${subscriptionData.additional_language_limit} additional languages`) }</span>
                            <table className="table table-sm border" style={{ maxWidth: "100%" }}>
                              <thead>
                                <tr>
                                  <th className="text-left"><Trans>Name</Trans></th>
                                  <th className="text-right"><Trans>Select</Trans></th>
                                </tr>
                              </thead>
                              <tbody>
                                {languageData?.map((i) => (
                                  <tr key={i.id}>
                                    <td className="text-left">{i.name}</td>
                                    <td className="text-right">
                                      <Control.checkbox
                                        model={`.lang-${i.id}`}
                                        onChange={() => onChangeModule(i, 'hesaablanguage')}
                                        disabled={selectedLang.length === subscriptionData.additional_language_limit && !selectedLangIds.includes(i.id)}
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </Col>
                        </Row>
                        <hr />
                      </>}

                      <BillingContactForm
                        addNewContact={addNewContact}
                        setAddNewContact={setAddNewContact}
                        billingData={billingData}
                        setBillingData={setBillingData}
                        setBillingAddressId={setBillingAddressId}
                        billingAddressId={billingAddressId}
                        countryOptions={countryOptions}
                        t={t}
                        colStyle={colStyle}
                        checkboxStyle={checkboxStyle}
                        styleCheck={styleCheck}
                        onCountryChangeHandler={handleBillingCountryChange}
                      />
                    </div>

                    <div className="col-md-5 col-lg-4">
                      <h4 className="d-flex justify-content-between align-items-center mb-3">
                        <span><Trans>{ t('Plan summary') }</Trans></span>
                      </h4>
                      
                      <FormGroup label={t("Plan Type *")} className="my-2" addControlClass={false}>
                        <Control.text style={{ backgroundColor: '#F4F7FE' }}
                          model=".plan_type"
                          component={Select}
                          options={planType}
                          simpleValue
                          clearable={false}
                          placeholder={('Select...')}
                          onChange={handleChange}
                          defaultValue={'Yearly'}
                          disabled={true}
                        />
                      </FormGroup>

                      <ul className="list-group mb-3 price-breakdown">
                        <li className="list-group-item d-flex justify-content-between lh-sm">
                          <div>
                            <h6 className="my-0"><Trans>{subscriptionData?.name || "Plan"}</Trans></h6>
                            <small className="text-muted"><Trans>{subscriptionData?.name || "Brief description"}</Trans></small>
                          </div>
                          <strong><CurrencySymbol currency={currency} /> {showPrice || "0.00"}</strong>
                        </li>

                        <li className="list-group-item d-flex justify-content-between">
                          <span><Trans>{ t(`Sub-total`) } (<CurrencySymbol currency={currency} />)</Trans></span>
                          <strong>{parseFloat(basePrice).toFixed(2)}</strong>
                        </li>

                        {vatAmount > 0 && (
                          <li className="list-group-item d-flex justify-content-between">
                            <span>
                              <Trans>VAT ({(subscriptionData?.vat_rate * 100).toFixed(0)}%)</Trans>
                              {isVatIncluded && <small className="text-muted"> - {t('Included in price')}</small>}
                              {!isVatIncluded && <small className="text-muted"> - {t('Added to price')}</small>}
                            </span>
                            <strong>{vatAmount.toFixed(2)}</strong>
                          </li>
                        )}

                        {changeType !== 'renew' && currentSubscriptionData?.current_plan?.unused_price > 0 && <li className="list-group-item d-flex justify-content-between">
                          <div>
                            <h6 className="my-0"><Trans>{ t(`Price adjustment`) }</Trans></h6>
                          </div>
                          <strong>{ `-${currentSubscriptionData?.current_plan?.unused_price?.toFixed(2)}` }</strong>
                        </li>}

                        {promoCodeData && promoCodeData?.discounted_price && (<li className="list-group-item d-flex justify-content-between bg-light">
                          <div className="text-success">
                            <h6 className="my-0"><Trans>{ t(`Promo code`) }</Trans></h6>
                            <small>{ promoCodeData?.code } { promoCodeData?.discount_type === 'Percent' && ` (${promoCodeData?.discount_amount}%)` }</small>
                          </div>
                          <span className="text-success">{promoCodeData?.discounted_price && `- ${promoCodeData?.discounted_price}`}</span>
                        </li>)}
                        
                        <li className="list-group-item d-flex justify-content-between">
                          <span><Trans>{ t(`Total`) } (<CurrencySymbol currency={currency} />)</Trans></span>
                          <strong>{ showTotalPrice(basePrice, vatAmount, promoCodeData?.discounted_price, currentSubscriptionData?.current_plan?.unused_price, changeType) }</strong>
                        </li>
                      </ul>

                      <FormGroup>
                        <div className="input-group">
                        {!promoCodeData ? <input 
                            type="text" 
                            className="form-control rounded"
                            placeholder={t("Promo code")}
                            onChange={(evt) => setPromoCode(evt.target.value)}
                          /> : <label className="form-control">{ promoCode }</label> }
                          
                          {!promoCodeData ? <button type="button" className="btn btn-secondary" onClick={applyPromoCode} disabled={!promoCode}><Trans>Apply</Trans></button> :
                          <button type="button" className="btn btn-danger" onClick={() => { setPromoCodeData(null); setPromoCode(null); }}><Trans>Remove</Trans></button>}
                        </div>
                      </FormGroup>

                      <FormGroup>
                        <h5 className="text-center text-success my-2">
                          The subscription will be valid from { formatDate(subscriptionPeriod.start_date) } to { formatDate(subscriptionPeriod.end_date) }.
                        </h5>
                      </FormGroup>

                      <FormGroup className="mt-4">
                        <SaveButton
                          type="submit"
                          className="btn-primary-filled btn-rounded btn-form-submit btn-rounded"
                          form={form}
                        >
                          <Trans>Continue to Payment</Trans>
                        </SaveButton>
                      </FormGroup>
                    </div>

                  </Row>
                </LocalForm>}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>

)
};

const enhance = compose(
  withTranslation(),
  withState("success", "setSuccess", null),
  withState("failure", "setFailure", null),
  withStateHandlers(
    {
      dispatch: null,
    },
    { setDispatch: () => (dispatch) => ({ dispatch }) }
  ),
);

export default enhance(PaymentSummary);
